// src/services/sessionService.js
var sessionId = sessionStorage.getItem('SESSION_ID');

export function getSessionId() {
  if (!sessionId) {
    sessionId = sessionStorage.getItem('SESSION_ID');
  }
  return sessionId;
}

export function setSessionId(id) {
  sessionId = id;
  sessionStorage.setItem('SESSION_ID', id);
}

export function clearSession() {
  sessionId = null;
  sessionStorage.removeItem('SESSION_ID');
}
